<template>
    <Icon :icon="icon" />
</template>

<script>
import { defineComponent } from 'vue';
import { Icon } from '@iconify/vue2';

export default defineComponent({
    name: 'IconIfyIcon',
    props: {
        icon: {
            type: String
        }
    },
    components: {
        Icon
    }
});
</script>

<style scoped lang='scss'>

</style>